import { ProcessLocationTypeDto } from '@/api/generated';
import { generalErrorTranslation } from '@/assets/locales/generalError/generalError.translation.pl.ts';
import { processCandidatesListTranslation } from '@/assets/locales/views/processes/details/list/processCandidatesList.translation.pl.ts';
import { ProcessDetailsTranslation } from '@/assets/locales/views/processes/details/processDetails.translation.en.ts';
import { quickTipsTranslation } from '@/assets/locales/views/processes/details/quickTips/quickTips.translation.pl.ts';
import { ProcessTab } from '@/views/processes/details/model/ProcessTabs.model.ts';

export const processDetailsTranslation: ProcessDetailsTranslation = {
  buttons: {
    edit: 'Edytuj',
    eRecruiter: 'eRecruiter',
    goToProcessList: 'Przejdź do listy procesów',
    hideProcessSummary: 'Ukryj szczegółu',
    runProcess: 'Uruchom',
    showProcessSummary: 'Pokaż szczegóły',
    startAnalysis: 'Rozpocznij analizę',
  },
  configuration: {
    cancel: 'Anuluj',
    description: 'Opis procesu',
    edit: 'Opis i intake call',
    emptyNote: 'Brak notatki z intake call',
    error:
      'Nie udało się zapisać zmian. Sprawdź, czy proces nadal oczekuje na konfigurację, i spróbuj ponownie.',
    intakeCall: 'Intake call',
    save: 'Zapisz',
    title: 'Opis procesu i intake call',
  },
  errors: {
    message: generalErrorTranslation.default,
  },
  extendedAtsIntegrationTooltip: 'Rozszerzona integracja z ATS',
  list: processCandidatesListTranslation,
  locationTypes: {
    [ProcessLocationTypeDto.Hybrid]: 'Hybrydowa',
    [ProcessLocationTypeDto.Office]: 'W biurze',
    [ProcessLocationTypeDto.Remote]: 'Zdalnie',
  },
  owner: {
    label: 'Właściciel',
    readOnly: 'Ten proces jest tylko do odczytu. Właściciel: {{owner}}.',
    unassigned: 'Brak właściciela',
  },
  quickTips: quickTipsTranslation,
  tabs: {
    [ProcessTab.CANDIDATE_LIST]: 'Kandydaci',
    [ProcessTab.PROCESS_INFORMATION]: 'Szczegóły procesu',
  },
  title: 'Szczegóły procesu',
};
